import { ref } from 'vue'

// Lets the currently-mounted TableToolbar (Directory, Students, Teachers,
// etc.) register its search input so the global "s" shortcut (AppRoot.vue)
// can jump straight to it without either side needing to know about the
// other's component tree. Module-level singleton — if more than one
// TableToolbar is ever mounted at once, the most recently mounted one wins.
//
// A page can instead claim "s" outright with an override ({ label, focus })
// — the Dashboard does, so "s" always means "Search students" there. Toolbars
// given a searchKey are also reachable by name via focusNamed().
const focusFn = ref(null)
const override = ref(null)
const named = {}

export function useActiveSearchFocus() {
  return {
    isAvailable: () => !!(override.value || focusFn.value),
    label: () => override.value?.label || 'Focus search on this page',
    register: fn => { focusFn.value = fn },
    unregister: fn => { if (focusFn.value === fn) focusFn.value = null },
    registerNamed: (key, fn) => { named[key] = fn },
    unregisterNamed: (key, fn) => { if (named[key] === fn) delete named[key] },
    focusNamed: key => { named[key]?.() },
    setOverride: o => { override.value = o },
    clearOverride: o => { if (override.value === o) override.value = null },
    focus: () => {
      const fn = override.value?.focus || focusFn.value
      if (!fn) return false
      fn()
      return true
    },
  }
}
